import { render } from "./PagamentoSorteRejeitada.vue?vue&type=template&id=17cbb394"
import script from "./PagamentoSorteRejeitada.vue?vue&type=script&lang=js"
export * from "./PagamentoSorteRejeitada.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__